import React from 'react';

const Privacy: React.FC = () => {
  return (
    <div className="container mx-auto px-6 py-16 max-w-3xl">
      <h1 className="text-3xl font-medium mb-8">Privacy Policy</h1>
      
      <div className="prose prose-lg">
        <p className="font-medium">We respect your privacy.</p>
        
        <p className="mt-4">This website does not collect personal data unless you choose to contact us. If you email us, we will only use your information to respond to your message.</p>
        
        <ul className="mt-4 list-disc pl-5 space-y-2">
          <li>We do not use cookies for tracking or advertising.</li>
          <li>We do not share your data with third parties.</li>
        </ul>
        
        <p className="mt-4">You can request to view or delete your data at any time by contacting us at jakub(at)substans.art.</p>
        
        <div className="mt-8">
          <p>Objects Gallery LTD</p>
          <p>Registered in England and Wales</p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
